// Shows `Layouts.confirm_dialog/1` in place of the browser's confirm box for every
// `data-confirm` control.
//
// phoenix_html asks with `window.confirm` from a bubbling `phoenix.link.click`
// listener on window. This capturing listener runs first: it stops that listener,
// cancels the click and opens the dialog. Confirming replays the click, which this
// listener then lets through without asking again.

const DESTRUCTIVE = ["delete", "remove", "discard", "revoke"];

const confirmed = new WeakSet();

function textFor(el) {
  const message = el.getAttribute("data-confirm");
  const split = message.indexOf("? ");
  const title = split === -1 ? message : message.slice(0, split + 1);
  const rest = split === -1 ? "" : message.slice(split + 2);
  const label = el.getAttribute("data-confirm-label") || title.split(/\s+/)[0].replace(/\W+$/, "");

  return {
    title,
    subject: el.getAttribute("data-confirm-subject") || "",
    body: el.getAttribute("data-confirm-body") || rest,
    label,
    destructive: DESTRUCTIVE.includes(label.toLowerCase()),
  };
}

function open(dialog, el) {
  const { title, subject, body, label, destructive } = textFor(el);
  const action = dialog.querySelector("[data-confirm-action]");

  dialog.querySelector("#confirm-dialog-title").textContent = title;
  dialog.querySelector("[data-confirm-subject]").textContent = subject ? `${subject} ` : "";
  dialog.querySelector("[data-confirm-text]").textContent = body;
  dialog.querySelector("#confirm-dialog-body").hidden = !subject && !body;
  action.textContent = label;
  action.classList.toggle("btn-error", destructive);
  action.classList.toggle("btn-accent", !destructive);

  dialog.returnValue = "";
  dialog.addEventListener(
    "close",
    () => {
      if (dialog.returnValue !== "confirm" || !el.isConnected) return;
      confirmed.add(el);
      el.click();
      // A disabled control fires no click, so the entry would skip the next confirm.
      confirmed.delete(el);
    },
    { once: true }
  );
  dialog.showModal();
}

window.addEventListener(
  "phoenix.link.click",
  (e) => {
    const el = e.target;
    if (!el.hasAttribute || !el.hasAttribute("data-confirm")) return;

    // Without the dialog, leave phoenix_html's own `window.confirm` to ask.
    const dialog = document.getElementById("confirm-dialog");
    if (!dialog) return;

    // Either way phoenix_html's own `window.confirm` must not run.
    e.stopPropagation();
    if (confirmed.delete(el)) return;

    e.preventDefault();
    open(dialog, el);
  },
  true
);

// Closing on a backdrop click, like the Portal's other dialogs.
document.addEventListener("click", (e) => {
  if (e.target.id === "confirm-dialog") e.target.close("cancel");
});
